import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { DashboardProjectDetails } from '../components/DashboardProjectDetails';
import { DashboardRomTemplates } from '../components/DashboardRomTemplates';
import { DashboardRomDocuments } from '../components/DashboardRomDocuments';
import { DashboardDocuments } from '../components/DashboardDocuments';
import { ProjectSelect } from '../components/ProjectSelect'

import Button from '@material-ui/core/Button';
import { inject, observer } from 'mobx-react';
import { stores } from '../store';

import ReactPlayer from 'react-player';

//import Accordion from '@mui/material/Accordion';
//import AccordionSummary from '@mui/material/AccordionSummary';
//import AccordionDetails from '@mui/material/AccordionDetails';
//import Typography from '@mui/material/Typography';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const HelpPage = inject("userStore")(observer(class HelpPage extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    async componentDidMount() {

    }

    render() {

        //const { } = this.state

        return (
            <Grid container>
                <Grid item xs={12}>
                    <p>ROMIS Manual Download Link:
                        <a href={global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/6"}
                            download="ROMISManual.pdf"> Link</a></p>
                </Grid>
                {
                    //<Grid item xs={12} >
                    //    <p>Administrator Manual Download Link:
                    //        <a href={global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/6"}> Link</a></p>
                    //</Grid>
                    //<Grid item xs={12} >
                    //    <p>Users Manual Download Link:
                    //        <a href={global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/7"}> Link</a></p>
                    //</Grid>
                }

                <Card>
                    <CardHeader title="Guidance Video for Admin Users" className="romis-card-header"></CardHeader>
                    <CardContent>
                        <ReactPlayer
                            url='/video/ROMISAdminVideo.mp4'
                            controls={true}
                        />
                    </CardContent>
                </Card>

                <Grid item xs={12}>
                    <br />
                </Grid>

                <Card>
                    <CardHeader title="Guidance Video for Expert Users" className="romis-card-header"></CardHeader>
                    <CardContent>
                        <ReactPlayer
                            url='/video/ROMISExpertsVideo.mp4'
                            controls={true}
                        />
                    </CardContent>
                </Card>

                <Grid item xs={12}>
                    <br />
                </Grid>

                <Card>
                    <CardHeader title="Guidance Video for Key Partners" className="romis-card-header"></CardHeader>
                    <CardContent>
                        <ReactPlayer
                            url='/video/ROMISKeyPartnersVideo.mp4'
                            controls={true}
                        />
                    </CardContent>
                </Card>

                <Grid item xs={12}>
                    <br />
                </Grid>

                <Card>
                    <CardHeader title="Guidance Video for Mission Coordinators" className="romis-card-header"></CardHeader>
                    <CardContent>
                        <ReactPlayer
                            url='/video/ROMISMissionCoordinatorVideo.mp4'
                            controls={true}
                        />
                    </CardContent>
                </Card>





            </Grid>
        );
    }
}))

export { HelpPage }



// WEBPACK FOOTER //
// ./src/pages/HelpPage.js